export default __webpack_public_path__ + "static/media/03_DAIF_Eco_05_HUGGING.f94b7638.mp4";